import { useRef } from 'react';
import { useField } from 'react-final-form';
import type { Period } from 'types';

export function useFiancePeriod(): Period | null {
  const {
    input: { value },
    meta: { valid },
  } = useField<Period | null>('finance_period', {
    allowNull: true,
    defaultValue: null,
    subscription: { value: true, valid: true },
  });

  const previous = useRef(value);

  if (valid && value !== previous.current) {
    previous.current = value;
  }

  return previous.current;
}
